import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const GET_COURSE = "GET_COURSE";
export const CAC_LOADING = "CAC_LOADING";
export const ADD_COURSE = "ADD_COURSE";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllCourses = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAC_LOADING
    });
    await instance.get(`/Courses/GetAllCourses/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_COURSES,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetCourseById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CAC_LOADING
    });
    await instance.get(`/Courses/GetCoursesById/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_COURSE,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const addCourse = data =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: CAC_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/Courses/PutInsUpdtCourse/${data.id}&${data.name}&${data.enableEnrrol}&${data.active}&${data.modified_By}&${Token}` ).then((res => {
            dispatch({
                type: ADD_COURSE,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
